export default __webpack_public_path__ + "static/media/logo2.6c59a6c0.png";